import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  width: 80%;
  color: #000;
  margin: 0 auto 10px;
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: ${props => props.space ? 'space-between' : 'center'};
`;

export const Link = styled.a`
  background-color: #3134EE;
  padding: 4px 8px;
  border: none;
  cursor: pointer;
  color: #fff;
  border-radius: 4px;
`;

export const Nav = styled.div`
  display: flex;
  justify-content: space-between;

  button{
    background-color: #888888;;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    min-width: 50px;
    cursor: pointer;
  }
`;

